import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import "./CardStyle.css";
import { themes, fonts } from "../themes/themes";

interface ICustomCardProps {
  cardSize: {
    card_title?: string;
  };
  cardWidth?: string;
  cardHeight?: string;
  showPadding?: boolean;
  isHeightAuto?: boolean;
}

const CustomCard: React.FC<React.PropsWithChildren<ICustomCardProps>> = ({
  children,
  cardSize,
  cardWidth = "17.875em",
  cardHeight = "21.188em",
  showPadding = false,
  isHeightAuto = true,
}) => {
  return (
    <Box
      className="customCard"
      style={{
        width: cardWidth,
        maxHeight: cardHeight,
        height: isHeightAuto ? "auto" : cardHeight,
      }}
    >
      {showPadding ? (
        <>
          <Grid container>
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Typography
                style={{
                  color: themes.blackDefault,
                  fontSize: fonts.header,
                  fontFamily: fonts.fontFamily,
                  fontWeight: "bold",
                }}
              >
                {cardSize.card_title}
              </Typography>
            </Grid>
          </Grid>

          <Box className="card__scrollbar" style={{ paddingBottom: "0.2em" }}>
            {children}
          </Box>
        </>
      ) : (
        <>
          <Grid container>
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Grid
                item
                xs={12}
                style={{
                  justifyContent: "right",
                }}
              >
                <Typography
                  style={{
                    color: themes.blackDefault,
                    fontSize: fonts.header,
                    fontFamily: fonts.fontFamily,
                    fontWeight: "bold",
                  }}
                >
                  {cardSize.card_title}
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          {children}
        </>
      )}
    </Box>
  );
};

export default CustomCard;
